<div class="container ">
    <div class="row justify-content-center">
        <div class="col-lg-6 col-xl-4 login-wrapper">
            <div class="row">
                <div class="col" style="padding-top: 20px;">
                    <h1>Welcome</h1>

                    <p>Please enter your password below</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <form [formGroup]="form" novalidate (ngSubmit)="submit()" class='form-inline'>
                        <label class="sr-only" for="pass">Password</label>
                        <input type="text" class="form-control mr-2 col-10" id="pass" formControlName="password"
                               type="password"
                               placeholder="Password" aria-describedby="password"/>
                        <button type="submit" [disabled]="!form.valid" class="btn btn-primary">Go</button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col" style="height:35px">
                    <div *ngIf="unauthorized" class="text-danger">
                        Unauthorized!!!
                    </div>
                    <div *ngIf="!unauthorized && !form.valid && !form.pristine" class="text-danger">
                        Can not submit empty field!!!
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--<div class="container">-->

<!--<form [formGroup]="form" novalidate (ngSubmit)="submit()" class='form-inline'>-->

<!--<div class="row">-->
<!--<div class="col form-group">-->
<!--&lt;!&ndash;<label for="pass">Password<span class="text-danger">*</span></label>&ndash;&gt;-->
<!--<label class="sr-only" for="pass">Password</label>-->
<!--&lt;!&ndash;<input id="pass" class="col-sm-3 pass-input" formControlName="password" type="password"&ndash;&gt;-->
<!--&lt;!&ndash;placeholder="Password" aria-describedby="password"/>&ndash;&gt;-->
<!--<button type="submit" [disabled]="!form.valid" class="btn btn-primary">Submit</button>-->
<!--<div *ngIf="unauthorized" class="text-danger">-->
<!--Unauthorized!!!-->
<!--</div>-->
<!--<div *ngIf="!form.valid && !form.pristine" class="text-danger">-->
<!--Can not submit empty field!!!-->
<!--</div>-->
<!--</div>-->
<!--</div>-->


<!--&lt;!&ndash; NOTE: the following is for testing purposes. This code should be removed, currently only visible when in devmode. &ndash;&gt;-->

<!--<div class="row" *ngIf="showErrorButtons">-->
<!--<div class="col" style="margin-top:80px;">-->
<!--<div style="text:center; font-size: 18px;padding:20px;">This is for developers testing only. Please-->
<!--ignore.-->
<!--Thank you.-->
<!--</div>-->
<!--<button type="button" class="btn btn-primary" (click)="throwClientSideTestError()">Raise a client-side-->
<!--error-->
<!--</button>-->
<!--<button type="button" class="btn btn-primary" (click)="throwServerSideTestError()">Raise a server-side-->
<!--error-->
<!--</button>-->
<!--</div>-->
<!--</div>-->
<!--&lt;!&ndash;  *********************************************************************** &ndash;&gt;-->


<!--</form>-->

<!--</div>-->
